import { useNavigate, useLocation } from "react-router-dom";
import { useState, useMemo, useEffect } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { SemiCircleProgress } from "react-semicircle-progressbar";
import {
  CommonImages,
  ProfileImages,
  UserAuqisitation,
  UserEngagement,
} from "../../../../reusableUI/images";
import Card from "../../../../reusableUI/CommonCardUi";
import SmallCard from "../../../../reusableUI/smallCard";
import CommonDropdown from "../../../../reusableUI/dropdown";
import Pagination from "@mui/material/Pagination";
import BookingChart from "../../../../Charts/bookingChart";
import PatientsAgeChart from "../../../../Charts/charts";
import PatientGenderChart from "../../../../Charts/patientGenderChart";
import DonutChart from "../../../../Charts/donutChart";
import ConversionFunnelChart from "../../../../Charts/conversionFunnelChart";
import BookingsBySpecialist from "../../../../Charts/bookingSpeciality";
import { getBookingsDetails } from "../../../../Service/bookings";
import ServiceChart from "../../../../Charts/serviceChart";
import AreaChart from "../../../../Charts/areaChart";
import moment from "moment";
import TabButtons from "../../../../reusableUI/tabButtons";
import {
  capitalizeFirstLetter,
  formatPhoneNumber,
} from "../../../../utils/Functions";
import UnassignedBookings from "./unassignedBookings";
import CancelledBookings from "./cancelledBookings";
import { Tooltip } from "antd";
import { Info } from "lucide-react";
import Page from "../../../../reusableUI/page";

const SortIcon = ({ isSorted, isSortedDesc }) => {
  if (!isSorted) {
    return (
      <img
        src={ProfileImages.filter}
        alt="filter"
        className="h-3 w-2 ml-1 cursor-pointer opacity-60"
      />
    );
  }

  if (isSortedDesc) {
    return (
      <svg
        className="h-3 w-3 ml-1 text-blue-600"
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path d="M5 8l5 5 5-5H5z" />
      </svg>
    );
  }

  return (
    <svg
      className="h-3 w-3 ml-1 text-blue-600"
      fill="currentColor"
      viewBox="0 0 20 20"
    >
      <path d="M15 12l-5-5-5 5h10z" />
    </svg>
  );
};

const Booking = () => {
  const [card, setCard] = useState(() => {
    return localStorage.getItem("bookings_active_tab") || "1";
  });
  const [option, setOption] = useState("Analytics");
  const [selectedValue, setSelectedValue] = useState("Last 30 days");
  const [filterType, setFilterType] = useState("All");
  const [paginationPage, setPaginationPage] = useState(0);
  const [bookingsDetaile, setBookingsDetaile] = useState([]);
  const [filteredBookingList, setFilteredBookingList] = useState([]);
  const [filteredPhysio, setFilteredPhysioList] = useState([]);
  const [filteredNurse, setFilteredNurseList] = useState([]);
  const [booked, setBooked] = useState([]);
  const [ageChart, setAgeChart] = useState([]);
  const [services, setServices] = useState([]);
  const [areas, setAreas] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [accepted, setAccepted] = useState([]);
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState("Analytics");
  const [repeated, setRepeated] = useState([]);
  const [newBookingCount, setNewBookingCount] = useState();

  useEffect(() => {
    getBooking();
  }, []);

  useEffect(() => {
    localStorage.setItem("bookings_active_tab", card);
  }, [card]);
  const location = useLocation();

  useEffect(() => {
    if (localStorage.getItem(card)) {
      setSelectedTab(localStorage.getItem(card));
    }
  }, [location.state]);

  const getBooking = async () => {
    const result = await getBookingsDetails();
    console.log(result);
    if (!result.error) {
      setBookingsDetaile(result.data);
      setBooked(result.data.bookings);

      const nurse = result.data.bookings.filter(
        (item) => item?.specialistInfo?.role === "nurse",
      );
      const physio = result.data.bookings.filter(
        (item) => item?.specialistInfo?.role === "physiotherapist",
      );

      setFilteredNurseList(nurse);
      setFilteredPhysioList(physio);
    }
  };
  console.log(bookingsDetaile);
  const options = [
    { label: "Today", value: "Today" },
    { label: "Last 7 days", value: "Last 7 days" },
    { label: "Last 30 days", value: "Last 30 days" },
    { label: "Over All", value: "Over All" },
  ];

  const liveOptions = [
    { label: "All", value: "live-all" },
    { label: "Not Started", value: "live-notStarted" },
    { label: "Duty Started", value: "live-startDuty" },
    { label: "Duty Ended", value: "live-endDuty" },
    // { label: "Accepted", value: "live-accepted" },
  ];

  const statusOptions = [
    { label: "All", value: "all" },
    { label: "Pending", value: "pending" },
    { label: "Rejected", value: "rejected" },
    { label: "Completed", value: "completed" },
    { label: "Not Available", value: "not available" },
    { label: "Expired", value: "expired" },
    { label: "Payment Pending", value: "payment pending" },
    { label: "Not Paid", value: "not paid" },
    { label: "Accepted", value: "accepted" },
    { label: "Duty Started", value: "startDuty" },
    { label: "Duty Ended", value: "endDuty" },
    { label: "In Complete", value: "incomplete" },
  ];

  const handleTimeframeChange = (e) => {
    setSelectedValue(e.target.value);
  };

  useEffect(() => {
    const filterUsersByTimeframe = (users, timeframe) => {
      const now = new Date();
      let startDate;

      if (timeframe === "Today") {
        startDate = new Date(now.setHours(0, 0, 0, 0));
      } else if (timeframe === "Last 7 days") {
        startDate = new Date(now.setDate(now.getDate() - 7));
      } else if (timeframe === "Last 30 days") {
        startDate = new Date(now.setDate(now.getDate() - 30));
      } else if (timeframe === "Over All") {
        return users;
      }

      return users.filter((user) => new Date(user.createdAt) >= startDate);
    };

    const filteredList = filterUsersByTimeframe(booked, selectedValue);
    const accepted = filteredList.filter((item) => item.status === "accepted");
    setAccepted(accepted);
    setFilteredBookingList(filteredList);
  }, [selectedValue, booked]);

  useEffect(() => {
    const usersWithAge = filteredBookingList
      .filter(
        (item) =>
          item?.patient?.userID?.personalInfo?.basicInfo?.otherInfo?.dob,
      )
      .map((item) => {
        const dob = new Date(
          item.patient.userID.personalInfo.basicInfo.otherInfo.dob,
        );
        const age = new Date().getFullYear() - dob.getFullYear();
        return {
          age,
          createdAt: item.createdAt,
          gender: item.patient.userID.personalInfo.basicInfo.otherInfo.gender,
          services: item.visitInfo.services,
        };
      });

    setAgeChart(usersWithAge);
    const servicesWithDate = filteredBookingList
      .filter(
        (item) =>
          item?.visitInfo?.services && Array.isArray(item?.visitInfo?.services),
      )
      .flatMap((item) =>
        item?.visitInfo?.services.map((service) => ({
          service,
          createdAt: item.createdAt,
        })),
      );

    setServices(servicesWithDate);

    const getArea = filteredBookingList
      .filter((item) => item?.visitInfo.addressInfo?.district)
      .map((item) => ({
        city: item?.visitInfo.addressInfo?.district,
        createdAt: item.createdAt,
      }));

    setAreas(getArea);

    const newBookings = filteredBookingList.map((item) => {
      const newBooking = item?.createdAt;
      return newBooking;
    });
    const newBookingCount = newBookings.length;
    // console.log(newBookingCount);
    setNewBookingCount(newBookingCount);

    const countRepeat = filteredBookingList.reduce((acc, item) => {
      const patientId = item?.patient?.patientID;

      if (patientId) {
        acc[patientId] = (acc[patientId] || 0) + 1;
      }
      return acc;
    }, {});

    const counts = Object.values(countRepeat);
    setRepeated(counts);
  }, [filteredBookingList]);

  const repeatedBookingsCount = repeated.filter((count) => count > 1).length;
  const totalBookingsCount = booked.length;

  const percentage = (repeatedBookingsCount / totalBookingsCount) * 100;
  // console.log(percentage);

  let conversion = (accepted.length / filteredBookingList.length) * 100;
  conversion = Math.round(conversion);

  const handleChange2 = (event, value) => {
    setPaginationPage(value - 1);
  };

  const handleStatusFrame = (e) => {
    setSelectedStatus(e.target.value);
  };

  const onSelect = (option) => {
    setSelectedTab(option);
  };

  const getColumns = () => {
    let baseColumns = [
      {
        Header: () => (
          <div className="font-poppins whitespace-nowrap text-[13px]">Name</div>
        ),
        accessor: "patient.name",
        id: "name",
        width: 200,
        minWidth: 180,
        maxWidth: 240,
        Cell: ({ row: { original } }) => (
          <div className="flex flex-row items-center gap-1.5 whitespace-nowrap ml-2">
            <div className="relative inline-block shrink-0">
              <img
                src={
                  original?.patient?.gender?.toLowerCase() === "female"
                    ? CommonImages.female
                    : original?.patient?.gender?.toLowerCase() === "male"
                      ? CommonImages.male
                      : CommonImages.defaultDp
                }
                alt="Profile"
                className="h-8 w-8 rounded-full object-cover"
              />
            </div>
            <span className="text-[#4361EE] font-poppins text-[13px] font-medium">
              {capitalizeFirstLetter(original?.patient?.name || "N/A")}
            </span>
          </div>
        ),
      },
      {
        Header: () => (
          <div className="font-poppins whitespace-nowrap text-[13px] ml-6">
            Date
          </div>
        ),
        accessor: "visitInfo",
        width: 170,
        minWidth: 150,
        maxWidth: 200,
        Cell: ({ row: { original } }) => {
          const start = original?.visitInfo?.startDate
            ? moment(original.visitInfo.startDate).format("DD/MM/YYYY")
            : "";
          const end = original?.visitInfo?.endDate
            ? moment(original.visitInfo.endDate).format("DD/MM/YYYY")
            : "";
          const days = parseInt(original?.visitInfo?.days) || 0;

          let dateText = "-";
          if (days === 1 || start === end) {
            dateText = start;
          } else if (start && end) {
            dateText = `${start} - ${end}`;
          } else if (start || end) {
            dateText = start || end;
          }

          return (
            <div className="font-poppins text-[13px] text-gray-700 whitespace-nowrap ml-6">
              {dateText}
            </div>
          );
        },
      },
      {
        Header: () => (
          <div className="font-poppins whitespace-nowrap text-[13px]">Time</div>
        ),
        accessor: "visitInfo.slot",
        width: 160,
        minWidth: 140,
        maxWidth: 190,
        Cell: ({ row: { original } }) => {
          const timeText = original?.visitInfo?.slot || "-";
          return (
            <div className="font-poppins text-[13px] text-gray-700 whitespace-nowrap">
              {timeText}
            </div>
          );
        },
      },
      {
        Header: () => (
          <div className="font-poppins whitespace-nowrap text-[13px]">
            Gender
          </div>
        ),
        accessor: "patient.gender",
        width: 90,
        minWidth: 80,
        maxWidth: 110,
        Cell: ({ row: { original } }) => (
          <div className="font-poppins text-[13px] text-gray-700">
            {capitalizeFirstLetter(original?.patient?.gender || "-")}
          </div>
        ),
      },
      {
        Header: () => (
          <div className="font-poppins whitespace-nowrap text-[13px]">
            Service
          </div>
        ),
        accessor: "specialistInfo.role",
        width: 140,
        minWidth: 120,
        maxWidth: 160,
        Cell: ({ row: { original } }) => {
          let roleStr = capitalizeFirstLetter(
            original?.specialistInfo?.role || "-",
          );
          if (
            roleStr.toLowerCase() === "physio" ||
            roleStr.toLowerCase() === "physiotherapist"
          ) {
            roleStr = "Physiotherapist";
          }
          return (
            <div className="font-poppins text-[13px] text-gray-700">
              {roleStr}
            </div>
          );
        },
      },
      {
        Header: () => (
          <div className="font-poppins whitespace-nowrap text-[13px]">
            Location
          </div>
        ),
        accessor: "visitInfo.addressInfo.district",
        width: 200,
        minWidth: 180,
        maxWidth: 250,
        Cell: ({ row: { original } }) => {
          const city = original?.visitInfo?.addressInfo?.city || "";
          const loc = [city]
            .filter(Boolean)
            .map(capitalizeFirstLetter)
            .join(", ");
          return (
            <div
              className="font-poppins text-[13px] text-gray-700 whitespace-normal break-words max-w-[230px]"
              title={loc || "-"}
            >
              {loc || "-"}
            </div>
          );
        },
      },
      {
        Header: () => (
          <div className="font-poppins whitespace-nowrap text-[13px]">
            Assigned to
          </div>
        ),
        accessor: "assignedTo",
        width: 160,
        minWidth: 140,
        maxWidth: 180,
        Cell: ({ row: { original } }) => {
          let displayAssignee = "-";
          if (original?.appointmentType?.type === "partner") {
            displayAssignee =
              original?.appointmentType?.partnerName ||
              original?.assignedTo ||
              "-";
          } else if (original?.appointmentType?.type === "self") {
            displayAssignee =
              original?.specialistInfo?.name || original?.assignedTo || "-";
          } else {
            displayAssignee = original?.assignedTo || "-";
          }

          return (
            <div className="font-poppins text-[13px] flex items-center gap-1.5 min-w-[160px]">
              <span
                className={`truncate max-w-[130px] ${displayAssignee !== "-" ? "text-[#4361EE] font-medium" : "text-gray-500"}`}
              >
                {displayAssignee}
              </span>
              {displayAssignee !== "-" && displayAssignee.length > 10 && (
                <Tooltip title={displayAssignee} placement="top">
                  <div className="cursor-pointer text-gray-400 hover:text-blue-600 shrink-0 mt-0.5">
                    <Info size={14} />
                  </div>
                </Tooltip>
              )}
            </div>
          );
        },
      },
      {
        Header: () => (
          <div className="font-poppins whitespace-nowrap text-[13px]">
            Status
          </div>
        ),
        accessor: "status",
        width: 120,
        minWidth: 110,
        maxWidth: 140,
        Cell: ({ row: { original } }) => {
          let statusText = "Status not available";
          if (original.status === "endDuty") statusText = "End Duty";
          else if (original.status === "pending") statusText = "Pending";
          else if (original.status === "startDuty") statusText = "Start Duty";
          else if (original.status === "accepted") statusText = "Not Started";
          else if (original.status === "payment pending")
            statusText = "Payment Pending";
          else if (original.status === "completed") statusText = "Completed";
          else if (original.status === "cancelled") statusText = "Cancelled";
          else if (original.status === "not paid")
            statusText = "Payment Pending";
          else if (
            original.status !== "completed" &&
            original.visitInfo?.endDuty &&
            new Date(original.visitInfo.endDuty) < new Date()
          )
            statusText = "InComplete";

          let colorClass = "text-[#00A86B]"; // default green
          if (statusText === "Pending" || statusText === "Payment Pending")
            colorClass = "text-orange-500";
          else if (statusText === "Cancelled" || statusText === "InComplete")
            colorClass = "text-red-500";
          else if (statusText === "Not Started") colorClass = "text-blue-500";

          return (
            <div
              className={`font-poppins text-[13px] font-medium whitespace-nowrap ${colorClass}`}
            >
              {statusText}
            </div>
          );
        },
      },
      {
        Header: () => (
          <div className="font-poppins whitespace-nowrap text-[13px]">
            Profile
          </div>
        ),
        accessor: "profile",
        width: 80,
        minWidth: 70,
        maxWidth: 90,
        Cell: ({ row: { original } }) => (
          <div className="flex flex-row items-center">
            <button
              onClick={() =>
                navigate(`/admin/bookingsProfile/${original._id}`, {
                  state: { user: original, card: selectedTab },
                })
              }
              className="text-[#4361EE] underline font-medium font-poppins text-[13px] hover:opacity-80"
            >
              View
            </button>
          </div>
        ),
      },
    ];

    return baseColumns;
  };

  const filteredData = useMemo(() => {
    const today = moment().startOf("day");
    const currentDate = moment();

    const isWithinVisitDates = (startDate, endDate, dutyType) => {
      const start = moment(startDate).startOf("day");
      const end = moment(endDate).startOf("day");

      if (dutyType === "oneTime") {
        return today.isSame(start) && today.isSame(end);
      }

      const adjustedStart = moment(startDate).add(1, "day").startOf("day");
      return today.isSameOrAfter(adjustedStart) && today.isSameOrBefore(end);
    };

    const hasDutyStatus = (dutyInfo, startVerified, endVerified) =>
      dutyInfo.some(
        (duty) =>
          moment(duty.date).isSame(currentDate, "day") &&
          duty.startDuty.verified === startVerified &&
          duty.endDuty.verified === endVerified,
      );
    console.log(selectedStatus);
    let statusFilteredData = booked;

    switch (selectedStatus) {
      case "all":
        statusFilteredData = booked;
        break;

      case "accepted":
        statusFilteredData = booked.filter(
          (item) => item.status === "accepted",
        );
        break;

      case "startDuty":
        statusFilteredData = booked.filter((item) =>
          hasDutyStatus(item.dutyInfo, true, false),
        );
        break;

      case "endDuty":
        statusFilteredData = booked.filter((item) =>
          hasDutyStatus(item.dutyInfo, true, true),
        );
        break;

      case "pending":
        statusFilteredData = booked.filter((item) => item.status === "pending");
        break;

      case "rejected":
        statusFilteredData = booked.filter(
          (item) => item.status === "rejected",
        );
        break;

      case "completed":
        statusFilteredData = booked.filter(
          (item) => item.status === "completed",
        );
        break;

      case "not available":
        statusFilteredData = booked.filter(
          (item) => item.status === "not available",
        );
        break;

      case "expired":
        statusFilteredData = booked.filter((item) => item.status === "expired");
        break;

      case "payment pending":
        statusFilteredData = booked.filter(
          (item) =>
            !item.paymentInfo?.paid && item.status === "payment pending",
        );
        break;

      case "not paid":
        statusFilteredData = booked.filter(
          (item) => !item.paymentInfo?.paid && item.status === "not paid",
        );
        break;

      case "incomplete":
        statusFilteredData = booked.filter((item) => {
          const endDate = moment(item.visitInfo.endDate);
          return currentDate.isAfter(endDate) && item.status !== "completed";
        });
        break;

      case "live-notStarted":
        statusFilteredData = booked.filter(
          (item) =>
            item.status === "accepted" &&
            isWithinVisitDates(
              item.visitInfo.startDate,
              item.visitInfo.endDate,
              item.dutyType,
            ) &&
            hasDutyStatus(item.dutyInfo, false, false),
        );
        break;

      case "live-startDuty":
        statusFilteredData = booked.filter(
          (item) =>
            isWithinVisitDates(
              item.visitInfo.startDate,
              item.visitInfo.endDate,
              item.dutyType,
            ) && hasDutyStatus(item.dutyInfo, true, false),
        );
        break;

      case "live-endDuty":
        statusFilteredData = booked.filter(
          (item) =>
            isWithinVisitDates(
              item.visitInfo.startDate,
              item.visitInfo.endDate,
              item.dutyType,
            ) && hasDutyStatus(item.dutyInfo, true, true),
        );
        break;

      case "live-all":
        statusFilteredData = booked.filter((item) =>
          isWithinVisitDates(
            item.visitInfo.startDate,
            item.visitInfo.endDate,
            item.dutyType,
          ),
        );
        break;

      default:
        statusFilteredData = booked;
        break;
    }

    if (filterType !== "All") {
      return statusFilteredData.filter(
        (item) => item?.appointmentType?.type === filterType.toLowerCase(),
      );
    }

    return statusFilteredData;
  }, [selectedStatus, filterType, booked]);

  // console.log(bookingsDetaile);
  // console.log("filteredData", filteredData);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page: tablePage,
    prepareRow,
    nextPage,
    previousPage,
    canPreviousPage,
    canNextPage,
    pageOptions,
    state: { pageIndex },
    gotoPage,
  } = useTable(
    {
      columns: useMemo(() => getColumns(), [selectedStatus]),
      data: filteredData,
      initialState: { pageSize: 12, pageIndex: paginationPage },
    },
    useSortBy,
    usePagination,
  );

  useEffect(() => {
    gotoPage(paginationPage);
  }, [paginationPage, gotoPage, filteredData]);
  // console.log(filteredData);

  const tabOptions = [
    { value: "Analytics", label: "Analytics", count: 0 },
    { value: "Booking List", label: "Booking List", count: 0 },
  ];

  const onClick = (c) => {
    setCard(c);
  };

  return (
    <div className="overflow-y-auto overflow-x-hidden bg-[#F3F6F5] w-[100%] h-[90vh] mb-10 pb-10">
      <div className="flex flex-row justify-center items-center w-[99%]">
        <Card
          title={"Total Bookings"}
          image={CommonImages.TotalBooking}
          image1={CommonImages.Up}
          count={bookingsDetaile?.totalBookings || 0}
          text={`${bookingsDetaile?.successfulBookings || 0} successful bookings out of ${bookingsDetaile?.totalBookings || 0} bookings`}
          page={card}
          id="1"
          onClick={() => onClick("1")}
          user={"booking"}
        />
        <Card
          title={"Unassigned Bookings"}
          image={CommonImages.report}
          image1={CommonImages.Up}
          count={bookingsDetaile?.pendingBookings || 0}
          text={"Higher than usual"}
          page={card}
          id="2"
          onClick={() => onClick("2")}
          user={"booking"}
          card={"booking2"}
        />
        <Card
          title={"Cancelled Booking"}
          image={CommonImages.success}
          image1={UserAuqisitation.down}
          count={bookingsDetaile?.cancelledBookings || 0}
          text={"Average number of sessions per user"}
          page={card}
          onClick={() => onClick("3")}
          id="3"
          user={"booking"}
          card={"booking2"}
        />
      </div>
      {card === "1" && (
        <>
          <TabButtons
            options={tabOptions}
            selectedOption={selectedTab}
            onSelect={onSelect}
          />
          {selectedTab === "Analytics" && (
            <div className=" h-[63vh]  mb-8">
              <div className="bg-white rounded-2xl shadow-md h-85 m-2">
                <div className="flex justify-between items-center p-2">
                  <p className="text-[14px] ml-5 mt-[-5px] font-semibold">
                    Number of Bookings
                  </p>

                  <CommonDropdown
                    options={options}
                    value={selectedValue}
                    onChange={handleTimeframeChange}
                  />
                </div>
                <div className="border-b border-[#D7E4EB] mb-2 mt-[-5px]"></div>
                <div className="text-center mt-5">
                  <p className="text-2xl font-bold">
                    {filteredBookingList.length}
                  </p>
                  <p className="text-sm text-[#1D1D22] mt-0">Total Bookings</p>
                </div>
                <div className="flex flex-row m-4">
                  <SmallCard
                    image1={UserEngagement.chart}
                    status={"Booking Conversion Rate"}
                    count={`${bookingsDetaile?.convertionRate || 0}%`}
                    image2={CommonImages.Up}
                  />
                  <SmallCard
                    image1={CommonImages.calender}
                    status={"Successfull bookings"}
                    count={bookingsDetaile?.successfulBookings || 0}
                    image2={CommonImages.Up}
                  />
                </div>
                {/* <div className="flex flex-row mt-[-28px] m-4">
              <SmallCard
                image1={pending}
                status={"Pending requests"}
                count={"78"}
                rating={"+2.7%"}
              />
              <SmallCard
                image1={calender}
                status={"Cancelled Bookings"}
                count={"78"}
                rating={"-1.4%"}
              />
            </div> */}
              </div>

              <div className="bg-white rounded-2xl shadow-md m-2 mt-[-5px]">
                <div className="flex justify-between items-start">
                  <p className="text-[14px] ml-3 p-3 font-semibold">Bookings</p>
                </div>
                <div className="border-b border-[#D7E4EB] mb-1 "></div>
                <div className="p-2 mt-4">
                  <BookingChart
                    bookingsData={filteredBookingList}
                    value={selectedValue}
                  />
                </div>
              </div>
              <div className="flex justify-row mb-3 gap-1 mt-3  w-full">
                <div className="mini-card bg-white w-1/3  rounded-2xl shadow-md pb-2 mx-2">
                  <p className="text-[14px] ml-3 font-semibold p-2 mt-1">
                    Patients Booking By Age
                  </p>
                  <div className="border-b border-[#D7E4EB]"></div>
                  <div className="flex flex-row items-center pl-4 mt-2">
                    <img
                      src={CommonImages.ageI}
                      className="h-2 w-2"
                      alt="Age Icon"
                    />
                    <p className="text-[12px] ml-2">Patients</p>
                  </div>
                  <div className="ml-2 mt-10">
                    <PatientsAgeChart
                      ageData={bookingsDetaile?.bookingsByAge}
                    />
                  </div>
                </div>

                <div className=" bg-white w-1/3 rounded-2xl shadow-md  pb-3">
                  <p className="text-[16px] md:text-[14px] p-2 ml-3 font-semibold mt-1">
                    Repeated Bookings
                  </p>
                  <div className="border-b border-[#D7E4EB]"></div>
                  <div className="flex flex-row justify-center mt-10 p-1">
                    <SemiCircleProgress
                      percentage={
                        bookingsDetaile?.repeatedBookings
                          ? (
                              ((bookingsDetaile?.repeatedBookings
                                ?.repeatedPatients || 0) /
                                (bookingsDetaile?.repeatedBookings
                                  ?.totalRepeatedBookings || 1)) *
                              100
                            ).toFixed(0)
                          : "0"
                      }
                      size={{
                        width: 120,
                        height: 120,
                      }}
                      strokeWidth={7}
                      strokeColor={"#FFCD71"}
                      bgStrokeColor={"#FDF0D8"}
                      hasBackground={"#FDF0D8"}
                      strokeLinecap={"square"}
                    />
                  </div>
                  <p className="text-center mt-2 text-[12px] md:text-[14px] mx-8">
                    {bookingsDetaile?.repeatedBookings?.repeatedPatients || 0}{" "}
                    repeated bookings out of{" "}
                    {bookingsDetaile?.repeatedBookings?.totalRepeatedBookings ||
                      0}
                  </p>
                </div>

                {/* Patients Bookings by Gender Card */}
                <div className="mini-card-b bg-white  w-1/3 rounded-2xl shadow-md pb-3 mx-2">
                  <p className="text-[14px] ml-3 font-semibold mt-1 p-2">
                    Patients Bookings by Gender
                  </p>
                  <div className="border-b border-[#D7E4EB]"></div>
                  <div className="flex flex-row items-center justify-center">
                    <PatientGenderChart
                      genderData={bookingsDetaile?.bookingsByGender}
                    />
                  </div>
                </div>
              </div>

              <ServiceChart value={selectedValue} data={services} />
              <ConversionFunnelChart
                data={bookingsDetaile?.conversionFunnel || []}
              />

              <div className="flex flex-row w-[100%] mt-[12px]  align-center pb-6">
                <div className="flex w-full h-[35vh]">
                  <BookingsBySpecialist
                    value={selectedValue}
                    nurseData={filteredNurse}
                    physioData={filteredPhysio}
                  />
                  {/* <PatientsBookingArea /> */}
                  <AreaChart value={selectedValue} data={areas} />
                </div>
              </div>
            </div>
          )}

          {selectedTab === "Booking List" && (
            <div className="bg-white p-3 rounded-2xl shadow-lg mb-3 mx-2 h-[80vh] mt-2 w-[99%] flex flex-col justify-between">
              <div className="flex justify-between items-center mt-[-10px]">
                <p className="text-lg ml-4 font-semibold">
                  {selectedStatus && `Booking List (${filteredData.length})`}
                </p>
                <div className="flex items-center gap-4 mb-4 mt-4 relative mr-4">
                  <div className="relative flex items-center">
                    <select
                      id="live-status"
                      value={selectedStatus}
                      onChange={handleStatusFrame}
                      className="border rounded-md text-[13px] text-blue-600 border-blue-600 py-1 px-3 pr-8 appearance-none outline-none font-poppins font-medium cursor-pointer bg-white"
                      style={{ borderWidth: 1.5 }}
                    >
                      <option disabled>Live</option>
                      {liveOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}

                      <option disabled>Status</option>
                      {statusOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-2 flex items-center text-blue-600">
                      <svg className="fill-current h-4 w-4" viewBox="0 0 20 20">
                        <path d="M7 10l5 5 5-5H7z" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex flex-col justify-between h-full mt-[-10px]">
                <div className="overflow-x-auto min-h-[66vh] max-h-[66vh]">
                  <div className="min-w-[1200px] w-full h-full">
                    <table {...getTableProps()} className="w-full">
                      <thead className="bg-[#F6F8FC] sticky top-0 z-10">
                        {headerGroups.map((headerGroup) => (
                          <tr
                            {...headerGroup.getHeaderGroupProps()}
                            key={headerGroup.id}
                          >
                            {headerGroup.headers.map((column) => (
                              <th
                                {...column.getHeaderProps(
                                  column.getSortByToggleProps(),
                                )}
                                key={column.id}
                                className="px-2 py-1.5 text-left text-[12px] font-medium text-[#8177A8] tracking-wider cursor-pointer hover:bg-gray-100 whitespace-nowrap"
                              >
                                <div className="flex items-center gap-1">
                                  {column.render("Header")}
                                  {column.canSort && (
                                    <SortIcon
                                      isSorted={column.isSorted}
                                      isSortedDesc={column.isSortedDesc}
                                    />
                                  )}
                                </div>
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody
                        {...getTableBodyProps()}
                        className="bg-white divide-y divide-gray-200"
                      >
                        {tablePage.map((row) => {
                          prepareRow(row);
                          return (
                            <tr
                              {...row.getRowProps()}
                              key={row.id}
                              className="hover:bg-gray-50 transition-colors"
                            >
                              {row.cells.map((cell) => (
                                <td
                                  {...cell.getCellProps()}
                                  key={cell.column.id}
                                  className="px-2 py-1.5 text-[12px] text-gray-700 whitespace-nowrap"
                                >
                                  {cell.render("Cell")}
                                </td>
                              ))}
                            </tr>
                          );
                        })}
                        {tablePage.length === 0 && (
                          <tr>
                            <td
                              colSpan={10}
                              className="text-center py-10 text-gray-500 text-sm"
                            >
                              No bookings found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="mb-2 mt-2">
                  <Page
                    paginationPage={paginationPage}
                    nextPage={nextPage}
                    previousPage={previousPage}
                    canPreviousPage={canPreviousPage}
                    canNextPage={canNextPage}
                    pageOptions={pageOptions}
                    screen="bookings"
                  />
                </div>
              </div>
            </div>
          )}
        </>
      )}

      {card === "2" && (
        <div className=" ">
          <UnassignedBookings data={bookingsDetaile} />
        </div>
      )}

      {card === "3" && (
        <div className=" ">
          <CancelledBookings data={bookingsDetaile} />
        </div>
      )}
    </div>
  );
};
export default Booking;
